<div class="let-modal" *ngIf="bulkFlow !== 'transfer-numbers'">
  <div class="modal-header hdr-bt-0">
    <h4 class="modal-title">{{title}}</h4>

    <button tabindex="0" type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="container">
      <div *ngIf="bulkFlow !== 'strategic-port-in' && bulkFlow !== 'tpop'">
        <div class="row">
          <div>
            <div class="modal-subtitle" [ngClass]="{'mt-12': isUDFDormancyEnabled}">{{subheader}}</div>
            <div class="modal-subtitle" *ngIf="!isUDFDormancyEnabled">{{authoringContentData?.bulkFlow?.genericNoteText}}</div>
            <div class="modal-subtitle" *ngIf="isUDFDormancyEnabled">{{authoringContentData?.bulkFlow?.udfGenericNoteText}}</div>
          </div>
        </div>
        <div class="row p-b-20" *ngIf="isExcel">
          <div class="col-12 pl-0">
            <div class="csv-dw-link">

              <a tabindex="0" [ngClass]="{'isDisabled': disableBulkLineIdentifier}" href="javascript:void(0)" id="download-template-ban" (click)="exportAsXLSX()" *ngIf="!isUDFDormancyEnabled">
                {{authoringContentData?.bulkFlow?.downloadNow}}
              </a>
              <div *ngIf="isUDFDormancyEnabled">
                <img src="../../assets/tfb-acctmgmt/images/icons/udfDownload.svg" alt="" class="exportIconRe" (click)="exportAsXLSX()">
                <a tabindex="0" [ngClass]="{'isDisabled': disableBulkLineIdentifier}" href="javascript:void(0)" id="redownload-template" (click)="exportAsXLSX()" class="redownload">
                  {{authoringContentData?.bulkFlow?.reDownload}}
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="row p-b-20" *ngIf="!isExcel">
          <div class="col-12 pl-0">
            <div class="csv-dw-link">

              <a tabindex="0" [ngClass]="{'isDisabled': disableBulkLineIdentifier}"href="javascript:void(0)" id="download-template-ban"
                (click)="exportAsCSV()">{{authoringContentData?.bulkFlow?.downloadNow}}</a>
            </div>
          </div>
        </div>
        <div *ngIf="showTechnicalIssuePopup">
          <div class="modal-header justify-content-start">
            <img src="/assets/tfb-acctmgmt/images/icons/redvalidator.png" class="m-r-15 errorIcon" alt="Transaction failed">
            <h4 class="modal-title mt-0" id="modal-basic-title">{{authoringContentData?.bulkFlow?.errorModalTitle}}</h4>
            <button tabindex="0" type="button" class="close" aria-label="Close" (click)="close()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row m-0">
              <div class="addGroup-label">
                <p>{{authoringContentData?.bulkFlow?.errorMessageBodyTxt}}
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="bulkFlow === 'strategic-port-in'">
        <div>
          <p class="body-font">{{authoringContentData.bulkFlow.stPortinBodyTxt}}</p>
        </div>
        <div>
          <p class="body-font">{{authoringContentData.bulkFlow.stPortinBodyTxt1}}</p>
        </div>

        <div class="popup-btn-class">
          <div class="txtColor">
            <button type="button" class="btn_fileType left_align" (click) = "exportXLSX()" data-dismiss="modal" id="xls-btn">
              <img _ngcontent-obv-c409="" src="../../assets/tfb-acctmgmt/images/Export_Magenta.svg" alt="" class="exportIcon">
              {{authoringContentData.bulkFlow.xlsFileBtnTxt}}</button>
              <div class="body-font-text">{{authoringContentData.bulkFlow.xlsFileBtnBodyTxt}}</div>
          </div>
          <div class="txtColor">              
              <button type="button" class="btn_fileType left_align" (click) = "exportCSV()" data-dismiss="modal" id="csv-btn">
                <img _ngcontent-obv-c409="" src="../../assets/tfb-acctmgmt/images/Export_Magenta.svg" alt="" class="exportIcon">
                {{authoringContentData.bulkFlow.csvFileBtnTxt}}</button>
                <div class="body-font-text">{{authoringContentData.bulkFlow.csvFileBtnBodyTxt}}</div>
          </div>
        </div>
        <div>
          <p class="body-font">{{authoringContentData.bulkFlow.stPortinBodyTxt2}}</p>
        </div>
        <div>
          <p class="body-font">{{authoringContentData.bulkFlow.stPortinBodyTxt3}}</p>
        </div>
      </div>

      <div *ngIf="bulkFlow === 'tpop'">
        <div>
          <p class="body-font">{{authoringContentData.bulkFlow.bulkTpopBody1}}</p>
        </div>
        <div>
          <p class="body-font">{{authoringContentData.bulkFlow.bulkTpopBody2}}</p>
        </div>

        <div class="popup-btn-class">
          <div>
            <span class="numColor">1) </span>
            <a tabindex="0" href="javascript:void(0)" class="upload-file-link-txt upload-style" (click) = "exportXLSX()" data-dismiss="modal" id="xls-btn">
             {{authoringContentData.bulkFlow.xlsFileDownloadTxt}}</a>
          </div>
          <div> 
            <span class="numColor">2) </span>             
            <a tabindex="0" href="javascript:void(0)" #inputFiles class="upload-file-link-txt upload-style"
            *ngIf="bulkFlow === 'tpop'">{{authoringContentData?.bulkFlow?.xlsFileUploadTxt}}
            <input tabindex="0" #fileInput class="file-type-link upload-pos" type="file" name="file"
              (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.xlsx']" />
          </a>
          </div>
        </div>
      </div>
      <!--Test fileUploadBox-->
      <div [ngClass]="{ 'fileUploadBox': !isUDFDormancyEnabled, 'fileUploadBoxUDF': isUDFDormancyEnabled, 'row' : isUDFDormancyEnabled }">
        <div *ngIf="!popuperror"> 
          <div *ngIf="(!(itemsUploadedSuccessfully > 0) || cancelFileUpload) && !isUDFDormancyEnabled" class="d-flex">
            <img src="/assets/tfb-acctmgmt/images/icons/iconUpload.svg" *ngIf="(!uploadProgressShow || cancelFileUpload) && bulkFlow !== 'strategic-port-in'"
              class="m-r-10" alt="Drag and drop file here or select 'Upload file'">
            <img src="/assets/tfb-acctmgmt/images/Upload_icon.svg" *ngIf="(!uploadProgressShow || cancelFileUpload) && bulkFlow === 'strategic-port-in'"
              class="m-r-10" alt="Drag and drop file here or select 'Upload file'"> 
            <span class="dragAndDrop"
              *ngIf="!uploadProgressShow || cancelFileUpload">{{authoringContentData?.bulkFlow?.dragAndDrop}}</span>
            <a tabindex="0" href="javascript:void(0)" class="upload-file-link-txt"
              *ngIf="(!uploadProgressShow || cancelFileUpload) && bulkFlow !== 'tpop'">{{authoringContentData?.bulkFlow?.uploadFile}}</a>

            <a tabindex="0" href="javascript:void(0)" #inputFiles class="upload-file-link"
              *ngIf="!uploadProgressShow || cancelFileUpload">
              <input tabindex="0" #fileInput *ngIf="isExcel" class="file-type-link" type="file" name="file"
                (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.csv','.xlsx']" />
              <input tabindex="0" #fileInput *ngIf="!isExcel" class="file-type-link" type="file" name="file"
                (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.csv','.xlsx']" />
            </a>

          </div>

          <div *ngIf="(!(itemsUploadedSuccessfully > 0) || cancelFileUpload) && isUDFDormancyEnabled" class="d-flex">
            <img src="/assets/tfb-acctmgmt/images/icons/iconUploadUDF.svg"
              *ngIf="(!uploadProgressShow || cancelFileUpload) && bulkFlow !== 'strategic-port-in'" class="m-r-10"
              alt="Drag and drop file here or select 'Upload file'">
          
            <span class="dragAndDrop"
              *ngIf="!uploadProgressShow || cancelFileUpload">{{authoringContentData?.bulkFlow?.dragAnDropUdf}}</span>
            <a tabindex="0" href="javascript:void(0)" class="upload-file-link-txt"
              *ngIf="(!uploadProgressShow || cancelFileUpload) && bulkFlow !== 'tpop'">{{authoringContentData?.bulkFlow?.uploadFileUDF}}</a>
            <span class="dragAndDrop"
              *ngIf="!uploadProgressShow || cancelFileUpload">{{authoringContentData?.bulkFlow?.dragAnDropUdfToUpload}}</span>
          
            <a tabindex="0" href="javascript:void(0)" #inputFiles class="upload-file-link"
              *ngIf="!uploadProgressShow || cancelFileUpload">
              <input tabindex="0" #fileInput *ngIf="isExcel" class="file-type-link" type="file" name="file"
                (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.csv','.xlsx']" />
              <input tabindex="0" #fileInput *ngIf="!isExcel" class="file-type-link" type="file" name="file"
                (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.csv','.xlsx']" />
            </a>

          </div>
          <div *ngIf="(uploadProgressShow && bulkFlow === 'tpop')">
            <div class="col-12" >
              <img src="/assets/tfb-acctmgmt/images/activeIcon.svg" class="m-r-10" alt="Upload successful'">Upload successful
            </div>
            <div class="col-12">
              <span class="file-name" id="filename">{{fileName}}</span>
            </div> 
            <div class="col-12">
              <button tabindex="0" type="button" class="remove-reupload" (click)="removeTpopFile()">Remove file</button>
            </div> 
          </div>
          
          <a tabindex="0" href="javascript:void(0)" #inputFiles class="upload-file-link-txt"
            *ngIf="uploadProgressShow && fileUploadingPercentage > 0 && fileUploadingPercentage < 100 && !cancelFileUpload;"
            (click)="resetModal()">{{authoringContentData?.bulkFlow?.cancel}}</a>
        </div>


        <!--File Error with Upload file button-->
        <div *ngIf="popuperror && bulkFlow !== 'tpop'" class="d-flex">
          <img src="/assets/tfb-acctmgmt/images/icons/redvalidator.png" class="m-r-10 responseIcon"
            alt="Error Uploading file, No Data found. Please try again">
          <span class="file-name" id="filename">{{fileName}}</span>
          <a tabindex="0" href="javascript:void(0)" class="upload-file-link-txt">{{authoringContentData?.bulkFlow?.uploadFile}}</a>
          <a tabindex="0" href="javascript:void(0)" #inputFiles class="upload-file-link" (click)="clickUploadReplaceFile('Upload')">
            <input tabindex="0" #fileInput *ngIf="isExcel" class="file-type-link" type="file" name="file"
              (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.csv','.xlsx']" />
            <input tabindex="0" #fileInput *ngIf="!isExcel" class="file-type-link" type="file" name="file"
              (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.csv','.xlsx']" />
          </a>
        </div>

        <div *ngIf="popuperror && bulkFlow === 'tpop'">
          <div class="col-12" >
            <img src="/assets/tfb-acctmgmt/images/icons/redvalidator.png" class="m-r-10 responseIcon" alt="Error in upload'">Upload failed
          </div>
          <div class="col-12">
            <span class="file-name" id="filename">{{fileName}}</span>
          </div> 
          <div class="col-12">
            <button tabindex="0" type="button" class="remove-reupload">Upload another file
              <input tabindex="0" #fileInput class="file-type-link" type="file" name="file"
              (click)="fileInput.value = null" (change)="uploadAgain($event)" [accept]="['.xlsx']" />
            </button>
          </div> 
        </div>

        <!-- Progress Bar Animation  -->
        <div *ngIf="uploadProgressShow && fileUploadingPercentage > 0 && fileUploadingPercentage < 100">
          <div class="upload-bx" id="dropped-content" *ngIf="!cancelFileUpload">
            <div class="row ml-0 mr-0 mb-2">
              <div class="uploadLink uploading" id="uploading">
                {{authoringContentData?.bulkFlow?.uploading}}</div>
              <div class="file-name" id="filename">{{fileName}}</div>
              <mat-progress-bar [value]="fileUploadingPercentage" mode="determinate"></mat-progress-bar>
              <div class="uploading" *ngIf="(progress !== 0 || total !== 0)">
                {{progress}} of {{total}} records uploaded
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Error Message Block-->
      <div *ngIf="popuperror || !(itemsUploadedSuccessfully > 0)" class="m-b-20 invalidFile">
        <span>{{popuperror}}</span>
      </div>

      <div *ngIf="showDownloadError" class="m-b-20 invalidFile">
        <span>{{authoringContentData?.bulkFlow?.failedDownloadError}}</span>
      </div>

      <!--Test fileUploadBox End-->

      <div class="d-flex flex-column justify-content-center flex-md-row justify-content-md-end m-t-50" *ngIf="bulkFlow === 'tpop'">
        <button tabindex="0" type="button" class="primary_btn m-b-10" (click)="submitTpopPinDataAfterUpload()"
          [disabled]="tpopError">{{authoringContentData?.bulkFlow?.CTABulkTpop}}</button>
      </div>

    </div>
  </div>
</div>

<!-- Transfer Number HTML -->

<div class="let-modal" *ngIf="bulkFlow === 'transfer-numbers'">
  <div class="modal-header hdr-bt-0">
    <h4 class="modal-title mt-0 p-b-20">{{title}}</h4>

    <button tabindex="0" type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <div>
      {{authoringContentData?.bulkFlow?.downloadPrepopulatedTemplate}}
    </div>
    <div class="p-t-20 p-b-20 p-l-20" *ngIf="hideXLSTemplateDownload">
      <img src="/assets/tfb-acctmgmt/images/icons/iconFileDownload.svg" class="m-r-10" (click)="exportAsXLSX()"
        alt="Download XKS template">
      <a tabindex="0" href="javascript:void(0)" id="download-template-ban" (click)="exportAsXLSX()" class="download-file-link">
        {{authoringContentData?.bulkFlow?.xlsTemplate}}
      </a>
    </div>
    <div class="p-t-20 p-b-20 p-l-20" *ngIf="!hideXLSTemplateDownload">
      <img src="/assets/tfb-acctmgmt/images/icons/mask.svg" class="m-r-10" alt="">
      {{authoringContentData?.bulkFlow?.generatingSheetTxt}}</div>
    <div class="p-b-10">
      {{authoringContentData?.bulkFlow?.saveFileOnComputer}}
    </div>
    <div class="p-b-20">
      {{authoringContentData?.bulkFlow?.uploadSavedFile}}
    </div>
    <div>{{authoringContentData?.bulkFlow?.genericNoteText}}</div>
    <div class="fileUploadBox">
      <!-- Default View -->
      <div *ngIf="!popuperror">
        <div *ngIf="!(itemsUploadedSuccessfully > 0) || cancelFileUpload" class="d-flex">
          <img src="/assets/tfb-acctmgmt/images/icons/iconUpload.svg" *ngIf="!uploadProgressShow || cancelFileUpload" class="m-r-10"
            alt="Drag and drop file here or select 'Upload file'">
          <span class="dragAndDrop"
            *ngIf="!uploadProgressShow || cancelFileUpload">{{authoringContentData?.bulkFlow?.dragAndDrop}}</span>
          <a tabindex="0" href="javascript:void(0)" class="upload-file-link-txt"
            *ngIf="!uploadProgressShow || cancelFileUpload">{{authoringContentData?.bulkFlow?.uploadFile}}</a>
          <a tabindex="0" href="javascript:void(0)" #inputFiles class="upload-file-link"
            *ngIf="!uploadProgressShow || cancelFileUpload" (click)="clickUploadReplaceFile('Upload')">
            <input tabindex="0" #fileInput *ngIf="isExcel" class="file-type-link" type="file" name="file"
              (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.csv','.xlsx']" />
          </a>

        </div>
        <a tabindex="0" href="javascript:void(0)" #inputFiles class="upload-file-link-txt"
          *ngIf="uploadProgressShow && fileUploadingPercentage > 0 && fileUploadingPercentage < 100 && !cancelFileUpload;"
          (click)="resetModal()">{{authoringContentData?.bulkFlow?.cancel}}</a>
      </div>

      <!--File Error with Upload file button-->
      <div *ngIf="popuperror || showTimeErrorBelowReviewStatement" class="d-flex">
        <img src="/assets/tfb-acctmgmt/images/icons/redvalidator.png" class="m-r-10 responseIcon"
          alt="Error Uploading file, No Data found. Please try again">
        <span class="file-name" id="filename">{{fileName}}</span>
        <a tabindex="0" href="javascript:void(0)" class="upload-file-link-txt">{{authoringContentData?.bulkFlow?.uploadFile}}</a>
        <a tabindex="0" href="javascript:void(0)" #inputFiles class="upload-file-link" (click)="clickUploadReplaceFile('Upload')">
          <input tabindex="0" #fileInput *ngIf="isExcel" class="file-type-link" type="file" name="file"
            (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.csv','.xlsx']" />
        </a>
      </div>

      <!-- File Uploaded and want to replace file -->
      <div *ngIf="itemsUploadedSuccessfully > 0 && !uploadProgressShow && !popuperror" class="d-flex">
        <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseIcon" alt="Uploaded successfully">
        <span class="file-name" id="filename">{{fileName}} {{authoringContentData?.bulkFlow?.uploadedText}}</span>
        <a tabindex="0" href="javascript:void(0)" class="upload-file-link-txt">{{authoringContentData?.bulkFlow?.replaceFile}}</a>
        <a tabindex="0" href="javascript:void(0)" #inputFiles class="upload-file-link" (click)="clickUploadReplaceFile('Replace')">
          <input tabindex="0" #fileInput *ngIf="isExcel" class="file-type-link" type="file" name="file"
            (click)="fileInput.value = null" (change)="getIncomingFile($event)" [accept]="['.csv','.xlsx']" />
        </a>
      </div>

      <!-- Progress Bar Animation  -->
      <div *ngIf="uploadProgressShow && fileUploadingPercentage > 0 && fileUploadingPercentage < 100">
        <div class="upload-bx-tfNum" id="dropped-content" *ngIf="!cancelFileUpload">
          <div class="row ml-0 mr-0 mb-2">
            <div class="uploadLink uploading" id="uploading">
              {{authoringContentData?.bulkFlow?.uploading}}</div>
            <div class="file-name" id="filename">{{fileName}}</div>
            <mat-progress-bar [value]="fileUploadingPercentage" mode="determinate"></mat-progress-bar>
            <div class="uploading" *ngIf="(progress !== 0 || total !== 0)">
              {{progress}} of {{total}} records uploaded
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Error Message Block-->
    <div *ngIf="popuperror || !(itemsUploadedSuccessfully > 0)" class="m-b-20 invalidFile">
      <span>{{popuperror}}</span>
    </div>

    <!-- No of items uploaded successfully with no error -->
    <div class="m-b-20 m-t-20 successFile" *ngIf="itemsUploadedSuccessfully > 0 && !popuperror && !cancelFileUpload">
      <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
      <span>{{itemsUploadedSuccessfully}} {{authoringContentData?.bulkFlow?.itemsUploadedSuccessfully}}</span>
    </div>

    <div class="success-issues-report" *ngIf="showTimeErrorBelowReviewStatement === true">
      <div class="m-b-10 successFile" *ngIf="itemsUploadedSuccessfully === 0">
        <img src="/assets/tfb-acctmgmt/images/icons/successIcon.svg" class="m-r-10 responseMsgIcon" alt="Uploaded successfully">
        <span>{{transferNumberLines.length}}
          {{authoringContentData?.bulkFlow?.itemsUploadedSuccessfullyText}}</span>
      </div>
      <div class="successFile">
        <img src="/assets/tfb-acctmgmt/images/icons/error.svg" class="m-r-10 responseMsgIcon" alt="Issues found">
        <span>{{linesWithError.length}} {{authoringContentData?.bulkFlow?.issuesFound}}</span>
      </div>
      <p class="pt-3">{{authoringContentData?.transferNumberAuthoring?.invalidPortTimeErrMsg}}</p>
    </div>

    <div class="m-b-20 m-t-20 businessAdvisemen"
      *ngIf="itemsUploadedSuccessfully > 0 && !popuperror && !cancelFileUpload && showTimeErrorBelowReviewStatement === false">
      <hr>
      <h5 class="p-t-20 p-b-10">{{authoringContentData?.bulkFlow?.businessAdvisementsTitle}}</h5>
      <p class="p-b-10" [innerHTML]="this.authoringContentData.transferNumberAuthoring.tnBusinessAdswriteUp"></p>
      <hr>
    </div>

    <div class="d-flex flex-column justify-content-center flex-md-row justify-content-md-end m-t-50">
      <button tabindex="0" type="button" class="secondary_btn m-r-10 m-b-10"
        (click)="cancel()">{{authoringContentData?.bulkFlow?.cancel}}</button>
      <button tabindex="0" type="button" class="primary_btn m-b-10" (click)="submitTransferNumberRequest()"
        [disabled]="popuperror || cancelFileUpload || itemsUploadedSuccessfully === 0 || totalIssuesFound > 0 || totalIssuesFound != 0 || isTransferBulkReadOnly">{{authoringContentData?.bulkFlow?.SubmitBtn}}</button>
    </div>
  </div>

</div>
